import React from 'react';

import { SelectWithConfirm } from 'shared-components';

import { DropdownOptions } from './helpers';
import { TravelStatusEnum } from 'types';
import { useTranslation } from "react-i18next";

interface IProps {
  setArrivalStatus: (arrivalStatus: TravelStatusEnum) => void;
  setIsEdited: () => void;
  arrivalStatus: TravelStatusEnum | undefined;
}

export const ArrivalStatusSelection = ({ setArrivalStatus, arrivalStatus, setIsEdited }: IProps) => {
    const { t } = useTranslation('dialogs');
  const handleStatusChange = (evt: React.FormEvent<HTMLSelectElement>) => {
    setIsEdited();
    setArrivalStatus(evt.currentTarget.value as TravelStatusEnum);
  };

  return (
    <>
      <SelectWithConfirm
        id={'arrivalStatus'}
        label={t('dialogs:arrivalStatus')}
        options={DropdownOptions}
        value={arrivalStatus}
        placeHolder={t('dialogs:select')}
        onChange={(evt: any) => handleStatusChange(evt)}
      />
    </>
  );
};
